import type { ReactNode } from 'react';
import { cn } from '../ui/cn';

/**
 * Task and sub-module lists wrap onto extra rows (ADR-014 Amendment 18).
 * Each item stays on one line; the row wraps. This component **is** the `<nav>`
 * landmark — callers must not wrap it in a second `<nav>` (NF-10 two-nav contract).
 */
export const taskNavListClassName = 'm-0 flex list-none flex-wrap gap-1 p-0';

export interface ScrollNavBarProps {
  /** Landmark accessible name — e.g. "Modules" or module label for tier-2. */
  'aria-label': string;
  children: ReactNode;
  className?: string;
}

export function ScrollNavBar({
  'aria-label': ariaLabel,
  children,
  className,
}: ScrollNavBarProps) {
  return (
    <nav aria-label={ariaLabel} className={cn('border-b border-border bg-workspace', className)}>
      <div className="px-4">{children}</div>
    </nav>
  );
}
